export default __webpack_public_path__ + "static/media/mural-ellipse.c16828fc.svg";